import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'

import { Button, TextField } from '@mui/material';
import { ToastContainer } from 'react-toastify';

import './Login.css';
import 'react-toastify/dist/ReactToastify.css';
import { AuthService } from '../../services/AuthService';
import BasicCard from '../../components/card/Card';

import image4 from '../../assets/logo2.jpg';
import { mostraMensagemErro, mostraMensagemSucesso } from '../../helpers/Notificacoes';
import { validarSenha } from '../../helpers/utils';
import MensagemVerificacaoSenha from '../../components/mensagemVerificacaoSenha/mensagemVerificacaoSenha';


function NovaSenha() {

    const authService = new AuthService();

    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [erro, setErro] = useState<string | null>(null);
    const [confirmPassword, setConfirmPassword] = useState('');
    const { token } = useParams();

    const navigate = useNavigate();

    useEffect(() => {
        const validarSenhas = () => {
            if (password === '') {
                setErro(null);
                return;
            }

            const senhaValida = validarSenha(password);
            if (!senhaValida.status) {
                setErro(senhaValida.error ? senhaValida.error : 'Senha inválida!');
                return;
            }
            
            setErro(null);

            if (confirmPassword === '') {
                return;
            }

            if (password !== confirmPassword) {
                setErro('As senhas não coincidem.');
            }
        };

        validarSenhas();
    }, [password, confirmPassword]);


    async function criaNovaSenha() {

        const resposta = await authService.criaNovaSenha(
            password,
            token!,
            "/v1/usuario",
        ).then((response: any) => {
            return response;
        })
            .catch((error: any) => {
                return error;
            });

        if (resposta.codigo !== 200) {
            await mostraMensagemErro(resposta.mensagem || 'Erro ao cadastrar nova senha.');
            setUser('');
            setPassword('');
            setConfirmPassword('');

        } else {
            await mostraMensagemSucesso('Nova senha cadastrada com sucesso, efetue o login');
            setTimeout(() => {
                navigate("/");
            }, 5000);
        }
    }


    return (
        <div className="Login">
            <div className="LoginBottom">
                <BasicCard>
                    <div className="logo-container">
                        <img
                            src={image4}
                            alt="Logo"
                            style={{ width: 200, height: 80, marginBlockStart:-45 }}
                        />
                    </div>
                    <TextField
                        className="fields"
                        required
                        id="filled-password-input"
                        label="Senha"
                        type="password"
                        autoComplete="current-password"
                        variant="outlined"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        sx={{ marginBottom: 3 }}
                    />
                    <TextField
                        className="fields"
                        required
                        id="filled-confirm-password-input"
                        label="Confirme a Senha"
                        type="password"
                        autoComplete="current-password"
                        variant="outlined"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        sx={{ marginBottom: 1.5 }}
                    />
                     <MensagemVerificacaoSenha erros={erro!} />
                    <Button
                        variant="contained"
                        onClick={criaNovaSenha}
                        sx={{
                            width: { xs: '100%', sm: '80%', md: '70%' },
                            maxWidth: 300,
                            backgroundColor: '#5693B9',
                            marginTop:1.5
                        }}
                    >
                        Alterar senha
                    </Button>
                    <ToastContainer />
                    <div style={{ marginTop: '16px', textAlign: 'center' }}>
                        <a href="/" style={{ textDecoration: 'none', color: '#5693B9' }}>
                            Voltar
                        </a>
                    </div>
                </BasicCard>
            </div>
        </div>
    );
}

export default NovaSenha;